import { render, staticRenderFns } from "./MobileNotificationCenter.vue?vue&type=template&id=567c1fa5"
import script from "./MobileNotificationCenter.vue?vue&type=script&lang=js"
export * from "./MobileNotificationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports